import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DrugItem } from 'src/api/types';
import getMultipleDrugs from 'src/api/requests/getMultipleDrugs';
import { zustandViewedDrugsStorageName } from 'src/utils/cookieHelper';
import useStore from './useStore';

interface State {
  setViewedDrug: (id: string) => void;
  viewedDrugsList: DrugItem[];
  isLoading: boolean;
  loadCount: number;
}

const useViewedDrugsStore = create<State>()(
  persist(
    (set, get) => ({
      setViewedDrug: async (id: string) => {
        const currentList = get().viewedDrugsList.map(
          (item) => item.translitName
        );
        if (!currentList?.includes(id)) {
          // save only 10 last viewed drugs
          if (currentList?.length >= 10) {
            currentList.shift();
          }
          currentList.push(id);
          set({ isLoading: true });
          const viewedDrugs = await getMultipleDrugs({ ids: currentList });
          if (viewedDrugs?.length) {
            set({ viewedDrugsList: viewedDrugs });
          }
          set((state) => ({
            isLoading: false,
            loadCount: state.loadCount + 1
          }));
        }
      },
      viewedDrugsList: [],
      isLoading: false,
      loadCount: 0
    }),
    {
      name: zustandViewedDrugsStorageName
    }
  )
);

const fallbackStore: State = {
  setViewedDrug: () => null,
  viewedDrugsList: [],
  isLoading: false,
  loadCount: 0
};

export default () =>
  useStore<State>(useViewedDrugsStore, (state) => state) ?? fallbackStore;
